import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=8e20878c&scoped=true"
import script from "./photo.vue?vue&type=script&lang=js"
export * from "./photo.vue?vue&type=script&lang=js"
import style0 from "./photo.vue?vue&type=style&index=0&id=8e20878c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e20878c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8e20878c')) {
      api.createRecord('8e20878c', component.options)
    } else {
      api.reload('8e20878c', component.options)
    }
    module.hot.accept("./photo.vue?vue&type=template&id=8e20878c&scoped=true", function () {
      api.rerender('8e20878c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ShopDetail/photo.vue"
export default component.exports